import { Typography } from '@mui/material'
import CardView from '../component/CardView'
import { useAppStateContext } from '../util/CommonState'
import { useEffect, useState } from 'react'
import { listUsers } from '../util/user/UserList'
import CircleProgressDialog from '../container/CircleProgressDialog'
import { getTenantList } from '../util/tenant/TenantAPIUtil'

const TopPage = () => {
  // const {value, setValue} = useAppStateContext();
  const [carddata,setCarddata] = useState([])
  const [open,setOpen] = useState(true);

  useEffect(()=>{
    if(carddata.length == 0){
      getInitialData();
    }
  },[carddata]);

  const getInitialData = async () => {
    const tenant = await listUsers("product");
    const admin = await listUsers("admin");
    const user = await listUsers("user");
    const list = await getTenantList();

    let topValue = [
      {title:'テナント数',value: list.length},
      {title:'システム管理ユーザ数',value: admin.count},
      {title:'一般ユーザ数',value: user.count},
      {title:'プロダクト管理ユーザ数',value: tenant.count},
    ]

    setCarddata(topValue);
    setOpen(false);
  }

  return (
    <>
      <Typography variant="h4">Dashboard</Typography>
      <CircleProgressDialog open={open} setOpen={setOpen} />
      <CardView data={carddata} />
    </>
  );
}

export default TopPage